import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeGetCall } from "../effects/requests";
import endpoints from "../utils/endpoints";
import {
  applyStylistThemeToDocument,
  clearStylistThemeFromDocument,
  getStylistCodeFromPathname,
  normalizeStylistThemeColors,
} from "../utils/stylistTheme";
import useStore from "../zustandstore";

/**
 * Loads stylist business theme colors for booking URLs and applies them globally.
 */
export default function StylistThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const setStylistUniqueCode = useStore((state: any) => state.setStylistUniqueCode);

  useEffect(() => {
    const stylistCode = getStylistCodeFromPathname(location.pathname);
    if (!stylistCode) {
      clearStylistThemeFromDocument();
      return;
    }

    setStylistUniqueCode(stylistCode);
    let cancelled = false;

    async function loadTheme() {
      try {
        const response: any = await makeGetCall({
          url: endpoints.shopify_customer_connect,
          params: { stylist_unique_code: stylistCode },
        });

        if (cancelled) {
          return;
        }

        const theme = normalizeStylistThemeColors(
          response?.data?.business_details?.theme_colors
        );
        applyStylistThemeToDocument(theme);
      } catch {
        if (!cancelled) {
          clearStylistThemeFromDocument();
        }
      }
    }

    loadTheme();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, setStylistUniqueCode]);

  return <>{children}</>;
}
